import React, { useState } from 'react';
import Intro from './components/Introduction/Introduction';
import Form from './components/Form/Form';
// Import contexts
import { FormDataProvider } from './globalState/FormDataContext';

import SubmitSuccess from './components/Form/SubmitConfirmation/Success';

function App() {
  const [isFormStarted, setIsFormStarted] = useState(true);
  const [isRecoverLinkPressed, setIsRecoverLinkPressed] = useState(false);
  const [formSubmitStatus, setFormSubmitStatus] = useState(null);

  return (
    <>
      <main className="wmcads-container wmcads-container--main wmcads-p-b-lg wmcads-grid">
        {!isFormStarted ? (
          <Intro setIsFormStarted={setIsFormStarted} />
        ) : (
          <FormDataProvider>
            {isFormStarted && formSubmitStatus === null && (
              <Form
                setFormSubmitStatus={setFormSubmitStatus}
                formSubmitStatus={formSubmitStatus}
                isRecoverLinkPressed={isRecoverLinkPressed}
                setIsRecoverLinkPressed={setIsRecoverLinkPressed}
                setIsFormStarted={setIsFormStarted}
              />
            )}

            {formSubmitStatus && <SubmitSuccess />}
          </FormDataProvider>
        )}
      </main>
    </>
  );
}

export default App;
